import React from 'react';
import { FileTextIcon, BookOpenIcon, NotebookPenIcon, FileIcon, PlayIcon, ListChecksIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
const sources = [{
  icon: FileTextIcon,
  label: 'Lecture slides'
}, {
  icon: BookOpenIcon,
  label: 'Textbooks'
}, {
  icon: NotebookPenIcon,
  label: 'Class notes'
}, {
  icon: FileIcon,
  label: 'PDFs'
}, {
  icon: PlayIcon,
  label: 'Videos'
}, {
  icon: ListChecksIcon,
  label: 'Study guides'
}];
const path = ['What to study', 'In what order', 'What to compare', 'What to remember', 'What to review next'];
export function ProblemSection() {
  return <section className="bg-sand-50 px-4 py-14 sm:py-20" data-id="element-281" data-mp="3lsdflxh43gu6">
      <div className="mx-auto w-full max-w-3xl" data-id="element-282" data-mp="3qqezulq9xm78">
        <h2 className="font-display text-[27px] font-bold leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-283" data-mp="3qr7xmx7991d8">
          Stop studying Prosthodontics without knowing what to study next
        </h2>

        <p className="mt-5 text-[15.5px] leading-relaxed text-navy-800/75 sm:text-lg" data-id="element-284" data-mp="1oyjpqajo1pr4">
          The problem isn't that you don't have enough information. The problem is that you have{' '}
          <strong className="font-bold text-navy-900" data-id="element-285" data-mp="1inykfxt4mv0b">too much information</strong>—and no system for
          organizing it.
        </p>

        <ul className="mt-6 grid grid-cols-2 gap-2.5 sm:grid-cols-3" data-id="element-286" data-mp="1whzbs6hr1fqn">
          {sources.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2 rounded-xl bg-white px-3 py-2.5 text-[13px] font-semibold text-navy-800 ring-1 ring-navy-800/8" data-id="element-287" data-mp="14op32ut6puur">
              <Icon className="h-4 w-4 shrink-0 text-navy-800/40" aria-hidden="true" data-id="element-288" data-mp="1dq6i09uuvqhv" />
              <span className="min-w-0 truncate" data-id="element-289" data-mp="18qk7w9abqqda">{label}</span>
            </li>)}
        </ul>

        <p className="mt-6 text-[15.5px] leading-relaxed text-navy-800/75 sm:text-lg" data-id="element-290" data-mp="2p4k1l2iktjs3">
          And when it's time to review, you end up starting from scratch.{' '}
          <strong className="font-bold text-navy-900" data-id="element-291" data-mp="2k7tngkqc0y9b">
            PROSTHO 360™ turns that information overload into a visual study path.
          </strong>
        </p>

        <div className="mt-7 rounded-2xl bg-navy-900 p-5 text-white sm:p-7" data-id="element-292" data-mp="1mq300cwv5l2d">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-aqua-200" data-id="element-293" data-mp="1qsra0nxbcy0x">
            A simple system that helps you know
          </p>
          <ol className="mt-4 space-y-2.5" data-id="element-294" data-mp="1vpzr0l6q6w0l">
            {path.map((step, i) => <li key={step} className="flex items-center gap-3" data-id="element-295" data-mp="z3o5r85ffnoa" data-mpi={i}>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-aqua-500 text-[12px] font-extrabold" data-id="element-296" data-mp="134gf01eatskk">
                  {i + 1}
                </span>
                <span className="text-[15px] font-semibold sm:text-base" data-id="element-297" data-mp="1ctrnpmx9wv7x">{step}</span>
              </li>)}
          </ol>
        </div>

        <div className="mt-8" data-id="element-298" data-mp="fdkfsj7ijv3a">
          <CheckoutButton label="I want to study with a system" sub="Instant access · $27 one-time payment" data-id="element-299" data-mp="kcxcrws3mijl" />
        </div>
      </div>
    </section>;
}